if (!customElements.get('aiv-size-guide')) {
  customElements.define('aiv-size-guide', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const opener = this.querySelector('.aiv-guide-open');
      opener.addEventListener('click', () => {
        this.previousOverflow = document.body.style.overflow;
        dialog.showModal();
        document.body.style.overflow = 'hidden';
      });
      this.querySelector('.aiv-guide-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const rect = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => {
        document.body.style.overflow = this.previousOverflow || '';
        dialog.querySelectorAll('video').forEach(video => video.pause());
        opener.focus();
      });
      this.querySelectorAll('[data-unit]').forEach(button => button.addEventListener('click', () => {
        this.querySelectorAll('[data-unit]').forEach(tab => tab.setAttribute('aria-pressed', String(tab === button)));
        this.querySelectorAll('[data-chart]').forEach(chart => chart.hidden = chart.dataset.chart !== button.dataset.unit);
      }));
    }
    disconnectedCallback() {
      const dialog = this.querySelector('dialog');
      if (dialog && dialog.open) { dialog.close(); document.body.style.overflow = this.previousOverflow || ''; }
    }
  });
}
